export const MenuList = [
	// Dashboard
	{
		title: "Dashboard",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M14.1667 8.33329H15.8333C17.5 8.33329 18.3333 7.49996 18.3333 5.83329V4.16663C18.3333 2.49996 17.5 1.66663 15.8333 1.66663H14.1667C12.5 1.66663 11.6667 2.49996 11.6667 4.16663V5.83329C11.6667 7.49996 12.5 8.33329 14.1667 8.33329Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.16667 18.3333H5.83333C7.5 18.3333 8.33333 17.5 8.33333 15.8333V14.1666C8.33333 12.5 7.5 11.6666 5.83333 11.6666H4.16667C2.5 11.6666 1.66667 12.5 1.66667 14.1666V15.8333C1.66667 17.5 2.5 18.3333 4.16667 18.3333Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5 8.33329C6.84095 8.33329 8.33333 6.84091 8.33333 4.99996C8.33333 3.15901 6.84095 1.66663 5 1.66663C3.15905 1.66663 1.66667 3.15901 1.66667 4.99996C1.66667 6.84091 3.15905 8.33329 5 8.33329Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15 18.3333C16.8409 18.3333 18.3333 16.8409 18.3333 15C18.3333 13.159 16.8409 11.6666 15 11.6666C13.1591 11.6666 11.6667 13.159 11.6667 15C11.6667 16.8409 13.1591 18.3333 15 18.3333Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M14.1667 8.33329H15.8333C17.5 8.33329 18.3333 7.49996 18.3333 5.83329V4.16663C18.3333 2.49996 17.5 1.66663 15.8333 1.66663H14.1667C12.5 1.66663 11.6667 2.49996 11.6667 4.16663V5.83329C11.6667 7.49996 12.5 8.33329 14.1667 8.33329Z"
					stroke="black"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.16667 18.3333H5.83333C7.5 18.3333 8.33333 17.5 8.33333 15.8333V14.1666C8.33333 12.5 7.5 11.6666 5.83333 11.6666H4.16667C2.5 11.6666 1.66667 12.5 1.66667 14.1666V15.8333C1.66667 17.5 2.5 18.3333 4.16667 18.3333Z"
					stroke="black"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5 8.33329C6.84095 8.33329 8.33333 6.84091 8.33333 4.99996C8.33333 3.15901 6.84095 1.66663 5 1.66663C3.15905 1.66663 1.66667 3.15901 1.66667 4.99996C1.66667 6.84091 3.15905 8.33329 5 8.33329Z"
					stroke="black"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15 18.3333C16.8409 18.3333 18.3333 16.8409 18.3333 15C18.3333 13.159 16.8409 11.6666 15 11.6666C13.1591 11.6666 11.6667 13.159 11.6667 15C11.6667 16.8409 13.1591 18.3333 15 18.3333Z"
					stroke="black"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "",
		text: "dashboard",
		role: "",
	},

	// Admin Managment
	{
		title: "Admin Managment",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M10.4166 18.3335H3.39998C2.43331 18.3335 1.64164 17.5585 1.64164 16.6085V4.2418C1.64164 2.05846 3.26664 1.06679 5.25831 2.04179L8.95831 3.85846C9.75831 4.25013 10.4166 5.29179 10.4166 6.17513V18.3335Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.3083 12.5501V15.7001C18.3083 17.5001 17.475 18.3335 15.675 18.3335H10.4166V8.68347L10.8083 8.76681L14.5583 9.60847L16.25 9.98347C17.35 10.2251 18.25 10.7918 18.3 12.3918C18.3083 12.4418 18.3083 12.4918 18.3083 12.5501Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.58331 7.50012H7.47497"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.58331 10.8334H7.47497"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.5583 9.60839V12.2917C14.5583 13.3251 13.7166 14.1667 12.6833 14.1667C11.65 14.1667 10.8083 13.3251 10.8083 12.2917V8.76672L14.5583 9.60839Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.3 12.3917C18.25 13.3751 17.4333 14.1667 16.4333 14.1667C15.4 14.1667 14.5583 13.3251 14.5583 12.2917V9.6084L16.25 9.9834C17.35 10.2251 18.25 10.7917 18.3 12.3917Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M10.4166 18.3335H3.39998C2.43331 18.3335 1.64164 17.5585 1.64164 16.6085V4.2418C1.64164 2.05846 3.26664 1.06679 5.25831 2.04179L8.95831 3.85846C9.75831 4.25013 10.4166 5.29179 10.4166 6.17513V18.3335Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.3083 12.5501V15.7001C18.3083 17.5001 17.475 18.3335 15.675 18.3335H10.4166V8.68347L10.8083 8.76681L14.5583 9.60847L16.25 9.98347C17.35 10.2251 18.25 10.7918 18.3 12.3918C18.3083 12.4418 18.3083 12.4918 18.3083 12.5501Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.58331 7.50012H7.47497"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.58331 10.8334H7.47497"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.5583 9.60839V12.2917C14.5583 13.3251 13.7166 14.1667 12.6833 14.1667C11.65 14.1667 10.8083 13.3251 10.8083 12.2917V8.76672L14.5583 9.60839Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.3 12.3917C18.25 13.3751 17.4333 14.1667 16.4333 14.1667C15.4 14.1667 14.5583 13.3251 14.5583 12.2917V9.6084L16.25 9.9834C17.35 10.2251 18.25 10.7917 18.3 12.3917Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		text: "admin_managment",
		content: [
			// Admins
			{
				title: "Admins",
				to: "/admins",
				text: "admins",
				role: "admins",
			},
			// Roles
			{
				title: "Roles",
				to: "/roles",
				text: "roles",
				role: "roles",
			},
		],
	},

	// Category Managment
	{
		title: "Category Managment",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 7.09984V3.3165C8.75001 2.1415 8.21667 1.6665 6.89167 1.6665H3.52501C2.20001 1.6665 1.66667 2.1415 1.66667 3.3165V7.0915C1.66667 8.27484 2.20001 8.7415 3.52501 8.7415H6.89167C8.21667 8.74984 8.75001 8.27484 8.75001 7.09984Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 16.475V13.1083C8.75001 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75001 17.8 8.75001 16.475Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 14.5835H17.0833"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
				<path
					d="M14.5833 17.0835V12.0835"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 7.09984V3.3165C8.75001 2.1415 8.21667 1.6665 6.89167 1.6665H3.52501C2.20001 1.6665 1.66667 2.1415 1.66667 3.3165V7.0915C1.66667 8.27484 2.20001 8.7415 3.52501 8.7415H6.89167C8.21667 8.74984 8.75001 8.27484 8.75001 7.09984Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 16.475V13.1083C8.75001 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75001 17.8 8.75001 16.475Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 14.5835H17.0833"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
				<path
					d="M14.5833 17.0835V12.0835"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
			</svg>
		),
		to: "category-managment",
		text: "category_management",
		role: "category_management",
	},
	// Courts
	{
		title: "Courts",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_929_10410)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M9.66667 8.98567V18.319C9.66667 18.5033 9.81567 18.6523 10 18.6523C10.1843 18.6523 10.3333 18.5033 10.3333 18.319V8.98567C10.3333 8.80133 10.1843 8.65233 10 8.65233C9.81567 8.65233 9.66667 8.80133 9.66667 8.98567ZM18.3333 11.9857C18.149 11.9857 18 12.1347 18 12.319V12.9857C18 13.17 18.149 13.319 18.3333 13.319C18.5177 13.319 18.6667 13.17 18.6667 12.9857V12.319C18.6667 12.1347 18.5177 11.9857 18.3333 11.9857ZM18.3333 10.6523H17.3333C16.2303 10.6523 15.3333 11.5493 15.3333 12.6523C15.3333 13.7553 16.2303 14.6523 17.3333 14.6523H18.3333C18.5177 14.6523 18.6667 14.5033 18.6667 14.319C18.6667 14.1347 18.5177 13.9857 18.3333 13.9857H17.3333C16.598 13.9857 16 13.3877 16 12.6523C16 11.917 16.598 11.319 17.3333 11.319H18.3333C18.5177 11.319 18.6667 11.17 18.6667 10.9857C18.6667 10.8013 18.5177 10.6523 18.3333 10.6523ZM18.3333 7.65233C15.5763 7.65233 13.3333 9.89533 13.3333 12.6523C13.3333 15.4093 15.5763 17.6523 18.3333 17.6523C18.5177 17.6523 18.6667 17.5033 18.6667 17.319C18.6667 17.1347 18.5177 16.9857 18.3333 16.9857C15.944 16.9857 14 15.0417 14 12.6523C14 10.263 15.944 8.319 18.3333 8.319C18.5177 8.319 18.6667 8.17 18.6667 7.98567C18.6667 7.80133 18.5177 7.65233 18.3333 7.65233ZM1.66667 13.319C1.851 13.319 2 13.17 2 12.9857V12.319C2 12.1347 1.851 11.9857 1.66667 11.9857C1.48233 11.9857 1.33333 12.1347 1.33333 12.319V12.9857C1.33333 13.17 1.48233 13.319 1.66667 13.319ZM1.66667 14.6523H2.66667C3.76967 14.6523 4.66667 13.7553 4.66667 12.6523C4.66667 11.5493 3.76967 10.6523 2.66667 10.6523H1.66667C1.48233 10.6523 1.33333 10.8013 1.33333 10.9857C1.33333 11.17 1.48233 11.319 1.66667 11.319H2.66667C3.402 11.319 4 11.917 4 12.6523C4 13.3877 3.402 13.9857 2.66667 13.9857H1.66667C1.48233 13.9857 1.33333 14.1347 1.33333 14.319C1.33333 14.5033 1.48233 14.6523 1.66667 14.6523ZM1.66667 17.6523C4.42367 17.6523 6.66667 15.4093 6.66667 12.6523C6.66667 9.89533 4.42367 7.65233 1.66667 7.65233C1.48233 7.65233 1.33333 7.80133 1.33333 7.98567C1.33333 8.17 1.48233 8.319 1.66667 8.319C4.056 8.319 6 10.263 6 12.6523C6 15.0417 4.056 16.9857 1.66667 16.9857C1.48233 16.9857 1.33333 17.1347 1.33333 17.319C1.33333 17.5033 1.48233 17.6523 1.66667 17.6523ZM6.74833 3.259C7.42567 3.31367 8.09267 3.07333 8.57967 2.586C9.06767 2.09833 9.30767 1.43067 9.25267 0.752333C8.64567 0.889667 8.08767 1.19233 7.63667 1.64333C7.17633 2.10367 6.88233 2.66667 6.74833 3.259ZM9.994 0.666667C9.968 0.666667 9.94233 0.67 9.91633 0.670667C9.996 1.55233 9.68567 2.42333 9.051 3.05733C8.482 3.62633 7.723 3.935 6.93667 3.935C6.84667 3.935 6.75633 3.92833 6.666 3.92033C6.64733 4.696 6.895 5.47633 7.413 6.10933L12.1037 1.41933C11.5097 0.932 10.7723 0.666667 9.994 0.666667ZM13.327 4C13.327 3.22167 13.0623 2.48433 12.575 1.89067L7.884 6.581C8.47833 7.06833 9.21567 7.33333 9.994 7.33333C10.0203 7.33333 10.0457 7.33 10.0717 7.32933C9.99233 6.44833 10.3023 5.57733 10.937 4.943C11.571 4.30867 12.4423 3.999 13.3233 4.07767C13.324 4.05167 13.327 4.026 13.327 4ZM13.242 4.741C12.5637 4.686 11.896 4.926 11.4083 5.41433C10.9207 5.90233 10.6803 6.57 10.7353 7.248C11.342 7.11067 11.9 6.80833 12.351 6.35733C12.8017 5.90633 13.1043 5.348 13.242 4.741ZM6.034 3.47867C6.03467 3.47533 6.03367 3.47167 6.03433 3.468C6.03467 3.46633 6.03567 3.465 6.036 3.46367C6.14867 2.625 6.52233 1.81467 7.16533 1.172C7.92133 0.416333 8.92567 0 9.994 0C11.0623 0 12.0667 0.416333 12.8223 1.172C13.5777 1.927 13.9937 2.93167 13.9937 4C13.9937 5.06833 13.5777 6.07333 12.8223 6.82867C12.067 7.584 11.0623 8 9.99433 8C8.926 8 7.921 7.584 7.16533 6.82833C6.253 5.916 5.879 4.669 6.034 3.47867ZM20 6.98567V18.319C20 19.238 19.2523 19.9857 18.3333 19.9857H1.66667C0.747667 19.9857 0 19.238 0 18.319V6.98567C0 6.06667 0.747667 5.319 1.66667 5.319H5.33333C5.51767 5.319 5.66667 5.468 5.66667 5.65233C5.66667 5.83667 5.51767 5.98567 5.33333 5.98567H1.66667C1.11533 5.98567 0.666667 6.43433 0.666667 6.98567V18.319C0.666667 18.8703 1.11533 19.319 1.66667 19.319H18.3333C18.8847 19.319 19.3333 18.8703 19.3333 18.319V6.98567C19.3333 6.43433 18.8847 5.98567 18.3333 5.98567H14.6667C14.4823 5.98567 14.3333 5.83667 14.3333 5.65233C14.3333 5.468 14.4823 5.319 14.6667 5.319H18.3333C19.2523 5.319 20 6.06667 20 6.98567Z"
						fill="#FFF"
					/>
				</g>
				<defs>
					<clipPath id="clip0_929_10410">
						<rect width="20" height="20" fill="white" />
					</clipPath>
				</defs>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_929_10410)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M9.66667 8.98567V18.319C9.66667 18.5033 9.81567 18.6523 10 18.6523C10.1843 18.6523 10.3333 18.5033 10.3333 18.319V8.98567C10.3333 8.80133 10.1843 8.65233 10 8.65233C9.81567 8.65233 9.66667 8.80133 9.66667 8.98567ZM18.3333 11.9857C18.149 11.9857 18 12.1347 18 12.319V12.9857C18 13.17 18.149 13.319 18.3333 13.319C18.5177 13.319 18.6667 13.17 18.6667 12.9857V12.319C18.6667 12.1347 18.5177 11.9857 18.3333 11.9857ZM18.3333 10.6523H17.3333C16.2303 10.6523 15.3333 11.5493 15.3333 12.6523C15.3333 13.7553 16.2303 14.6523 17.3333 14.6523H18.3333C18.5177 14.6523 18.6667 14.5033 18.6667 14.319C18.6667 14.1347 18.5177 13.9857 18.3333 13.9857H17.3333C16.598 13.9857 16 13.3877 16 12.6523C16 11.917 16.598 11.319 17.3333 11.319H18.3333C18.5177 11.319 18.6667 11.17 18.6667 10.9857C18.6667 10.8013 18.5177 10.6523 18.3333 10.6523ZM18.3333 7.65233C15.5763 7.65233 13.3333 9.89533 13.3333 12.6523C13.3333 15.4093 15.5763 17.6523 18.3333 17.6523C18.5177 17.6523 18.6667 17.5033 18.6667 17.319C18.6667 17.1347 18.5177 16.9857 18.3333 16.9857C15.944 16.9857 14 15.0417 14 12.6523C14 10.263 15.944 8.319 18.3333 8.319C18.5177 8.319 18.6667 8.17 18.6667 7.98567C18.6667 7.80133 18.5177 7.65233 18.3333 7.65233ZM1.66667 13.319C1.851 13.319 2 13.17 2 12.9857V12.319C2 12.1347 1.851 11.9857 1.66667 11.9857C1.48233 11.9857 1.33333 12.1347 1.33333 12.319V12.9857C1.33333 13.17 1.48233 13.319 1.66667 13.319ZM1.66667 14.6523H2.66667C3.76967 14.6523 4.66667 13.7553 4.66667 12.6523C4.66667 11.5493 3.76967 10.6523 2.66667 10.6523H1.66667C1.48233 10.6523 1.33333 10.8013 1.33333 10.9857C1.33333 11.17 1.48233 11.319 1.66667 11.319H2.66667C3.402 11.319 4 11.917 4 12.6523C4 13.3877 3.402 13.9857 2.66667 13.9857H1.66667C1.48233 13.9857 1.33333 14.1347 1.33333 14.319C1.33333 14.5033 1.48233 14.6523 1.66667 14.6523ZM1.66667 17.6523C4.42367 17.6523 6.66667 15.4093 6.66667 12.6523C6.66667 9.89533 4.42367 7.65233 1.66667 7.65233C1.48233 7.65233 1.33333 7.80133 1.33333 7.98567C1.33333 8.17 1.48233 8.319 1.66667 8.319C4.056 8.319 6 10.263 6 12.6523C6 15.0417 4.056 16.9857 1.66667 16.9857C1.48233 16.9857 1.33333 17.1347 1.33333 17.319C1.33333 17.5033 1.48233 17.6523 1.66667 17.6523ZM6.74833 3.259C7.42567 3.31367 8.09267 3.07333 8.57967 2.586C9.06767 2.09833 9.30767 1.43067 9.25267 0.752333C8.64567 0.889667 8.08767 1.19233 7.63667 1.64333C7.17633 2.10367 6.88233 2.66667 6.74833 3.259ZM9.994 0.666667C9.968 0.666667 9.94233 0.67 9.91633 0.670667C9.996 1.55233 9.68567 2.42333 9.051 3.05733C8.482 3.62633 7.723 3.935 6.93667 3.935C6.84667 3.935 6.75633 3.92833 6.666 3.92033C6.64733 4.696 6.895 5.47633 7.413 6.10933L12.1037 1.41933C11.5097 0.932 10.7723 0.666667 9.994 0.666667ZM13.327 4C13.327 3.22167 13.0623 2.48433 12.575 1.89067L7.884 6.581C8.47833 7.06833 9.21567 7.33333 9.994 7.33333C10.0203 7.33333 10.0457 7.33 10.0717 7.32933C9.99233 6.44833 10.3023 5.57733 10.937 4.943C11.571 4.30867 12.4423 3.999 13.3233 4.07767C13.324 4.05167 13.327 4.026 13.327 4ZM13.242 4.741C12.5637 4.686 11.896 4.926 11.4083 5.41433C10.9207 5.90233 10.6803 6.57 10.7353 7.248C11.342 7.11067 11.9 6.80833 12.351 6.35733C12.8017 5.90633 13.1043 5.348 13.242 4.741ZM6.034 3.47867C6.03467 3.47533 6.03367 3.47167 6.03433 3.468C6.03467 3.46633 6.03567 3.465 6.036 3.46367C6.14867 2.625 6.52233 1.81467 7.16533 1.172C7.92133 0.416333 8.92567 0 9.994 0C11.0623 0 12.0667 0.416333 12.8223 1.172C13.5777 1.927 13.9937 2.93167 13.9937 4C13.9937 5.06833 13.5777 6.07333 12.8223 6.82867C12.067 7.584 11.0623 8 9.99433 8C8.926 8 7.921 7.584 7.16533 6.82833C6.253 5.916 5.879 4.669 6.034 3.47867ZM20 6.98567V18.319C20 19.238 19.2523 19.9857 18.3333 19.9857H1.66667C0.747667 19.9857 0 19.238 0 18.319V6.98567C0 6.06667 0.747667 5.319 1.66667 5.319H5.33333C5.51767 5.319 5.66667 5.468 5.66667 5.65233C5.66667 5.83667 5.51767 5.98567 5.33333 5.98567H1.66667C1.11533 5.98567 0.666667 6.43433 0.666667 6.98567V18.319C0.666667 18.8703 1.11533 19.319 1.66667 19.319H18.3333C18.8847 19.319 19.3333 18.8703 19.3333 18.319V6.98567C19.3333 6.43433 18.8847 5.98567 18.3333 5.98567H14.6667C14.4823 5.98567 14.3333 5.83667 14.3333 5.65233C14.3333 5.468 14.4823 5.319 14.6667 5.319H18.3333C19.2523 5.319 20 6.06667 20 6.98567Z"
						fill="black"
					/>
				</g>
				<defs>
					<clipPath id="clip0_929_10410">
						<rect width="20" height="20" fill="white" />
					</clipPath>
				</defs>
			</svg>
		),
		to: "courts",
		text: "courts",
		role: "courts",
	},

	// Market Place
	{
		title: "Market Place",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 7.09984V3.3165C8.75001 2.1415 8.21667 1.6665 6.89167 1.6665H3.52501C2.20001 1.6665 1.66667 2.1415 1.66667 3.3165V7.0915C1.66667 8.27484 2.20001 8.7415 3.52501 8.7415H6.89167C8.21667 8.74984 8.75001 8.27484 8.75001 7.09984Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 16.475V13.1083C8.75001 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75001 17.8 8.75001 16.475Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 14.5835H17.0833"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
				<path
					d="M14.5833 17.0835V12.0835"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 7.09984V3.3165C8.75001 2.1415 8.21667 1.6665 6.89167 1.6665H3.52501C2.20001 1.6665 1.66667 2.1415 1.66667 3.3165V7.0915C1.66667 8.27484 2.20001 8.7415 3.52501 8.7415H6.89167C8.21667 8.74984 8.75001 8.27484 8.75001 7.09984Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 16.475V13.1083C8.75001 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75001 17.8 8.75001 16.475Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 14.5835H17.0833"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
				<path
					d="M14.5833 17.0835V12.0835"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
			</svg>
		),
		text: "market_place",
		content: [
			// Products
			{
				title: "Products",
				to: "/products",
				text: "products",
				role: "products",
			},
			// Matches
			{
				title: "Matches",
				to: "/matches",
				text: "matches",
				role: "matches",
			},
			// Pin Market Place
			{
				title: "Pin Market Place",
				to: "/pin-market-place",
				text: "pin_market_place",
				role: "pin_market_place",
			},
		],
	},

	// Booking Managment
	{
		title: "Booking Managment",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M6.66667 1.6665V4.1665"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.3333 1.6665V4.1665"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M2.91667 7.5752H17.0833"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.0084 13.1416L13.0584 16.0916C12.9417 16.2082 12.8334 16.4249 12.8084 16.5832L12.65 17.7082C12.5917 18.1166 12.875 18.3999 13.2834 18.3416L14.4084 18.1833C14.5667 18.1583 14.7917 18.0499 14.9 17.9332L17.85 14.9833C18.3584 14.4749 18.6 13.8833 17.85 13.1333C17.1084 12.3916 16.5167 12.6332 16.0084 13.1416Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.5833 13.5664C15.8333 14.4664 16.5333 15.1664 17.4333 15.4164"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 18.3332H6.66667C3.75 18.3332 2.5 16.6665 2.5 14.1665V7.08317C2.5 4.58317 3.75 2.9165 6.66667 2.9165H13.3333C16.25 2.9165 17.5 4.58317 17.5 7.08317V9.99984"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M9.99624 11.4167H10.0037"
					stroke="#FFF"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.91192 11.4167H6.91941"
					stroke="#FFF"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.91192 13.9167H6.91941"
					stroke="#FFF"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M6.66667 1.6665V4.1665"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.3333 1.6665V4.1665"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M2.91667 7.5752H17.0833"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.0084 13.1416L13.0584 16.0916C12.9417 16.2082 12.8334 16.4249 12.8084 16.5832L12.65 17.7082C12.5917 18.1166 12.875 18.3999 13.2834 18.3416L14.4084 18.1833C14.5667 18.1583 14.7917 18.0499 14.9 17.9332L17.85 14.9833C18.3584 14.4749 18.6 13.8833 17.85 13.1333C17.1084 12.3916 16.5167 12.6332 16.0084 13.1416Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.5833 13.5664C15.8333 14.4664 16.5333 15.1664 17.4333 15.4164"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 18.3332H6.66667C3.75 18.3332 2.5 16.6665 2.5 14.1665V7.08317C2.5 4.58317 3.75 2.9165 6.66667 2.9165H13.3333C16.25 2.9165 17.5 4.58317 17.5 7.08317V9.99984"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M9.99624 11.4167H10.0037"
					stroke="#292D32"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.91192 11.4167H6.91941"
					stroke="#292D32"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.91192 13.9167H6.91941"
					stroke="#292D32"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		text: "booking_managment",
		content: [
			// Booking Requests
			{
				title: "Booking Requests",
				to: "/booking-requests",
				text: "booking_requests",
				role: "booking_requests",
			},
			// All Booking
			{
				title: "All Booking",
				to: "/all-booking",
				text: "all_booking",
				role: "all_booking",
			},
		],
	},

	// Notification
	{
		title: "Notification",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M19.34 14.49L18.34 12.83C18.13 12.46 17.94 11.76 17.94 11.35V8.82C17.94 6.47 16.56 4.44 14.57 3.49C14.05 2.57 13.09 2 11.99 2C10.9 2 9.92 2.59 9.4 3.52C7.45 4.49 6.1 6.5 6.1 8.82V11.35C6.1 11.76 5.91 12.46 5.7 12.82L4.69 14.49C4.29 15.16 4.2 15.9 4.45 16.58C4.69 17.25 5.26 17.77 6 18.02C7.94 18.68 9.98 19 12.02 19C14.06 19 16.1 18.68 18.04 18.03C18.74 17.8 19.28 17.27 19.54 16.58C19.8 15.89 19.73 15.13 19.34 14.49Z"
					fill="white"
				/>
				<path
					d="M14.83 20.01C14.41 21.17 13.3 22 12 22C11.21 22 10.43 21.68 9.87999 21.11C9.55999 20.81 9.31999 20.41 9.17999 20C9.30999 20.02 9.43999 20.03 9.57999 20.05C9.80999 20.08 10.05 20.11 10.29 20.13C10.86 20.18 11.44 20.21 12.02 20.21C12.59 20.21 13.16 20.18 13.72 20.13C13.93 20.11 14.14 20.1 14.34 20.07C14.5 20.05 14.66 20.03 14.83 20.01Z"
					fill="white"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M19.34 14.49L18.34 12.83C18.13 12.46 17.94 11.76 17.94 11.35V8.82C17.94 6.47 16.56 4.44 14.57 3.49C14.05 2.57 13.09 2 11.99 2C10.9 2 9.92 2.59 9.4 3.52C7.45 4.49 6.1 6.5 6.1 8.82V11.35C6.1 11.76 5.91 12.46 5.7 12.82L4.69 14.49C4.29 15.16 4.2 15.9 4.45 16.58C4.69 17.25 5.26 17.77 6 18.02C7.94 18.68 9.98 19 12.02 19C14.06 19 16.1 18.68 18.04 18.03C18.74 17.8 19.28 17.27 19.54 16.58C19.8 15.89 19.73 15.13 19.34 14.49Z"
					fill="#7B7B7B"
				/>
				<path
					d="M14.83 20.01C14.41 21.17 13.3 22 12 22C11.21 22 10.43 21.68 9.87999 21.11C9.55999 20.81 9.31999 20.41 9.17999 20C9.30999 20.02 9.43999 20.03 9.57999 20.05C9.80999 20.08 10.05 20.11 10.29 20.13C10.86 20.18 11.44 20.21 12.02 20.21C12.59 20.21 13.16 20.18 13.72 20.13C13.93 20.11 14.14 20.1 14.34 20.07C14.5 20.05 14.66 20.03 14.83 20.01Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		to: "/notification",
		text: "notification",
		role: "notification",
	},

	// Users
	{
		title: "Users",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		text: "users",
		to: "/users",
		role: "users",
	},

	// Subscription
	{
		title: "Subscription",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.22656 11.9422C7.22656 13.0172 8.05156 13.8839 9.07656 13.8839H11.1682C12.0599 13.8839 12.7849 13.1255 12.7849 12.1922C12.7849 11.1755 12.3432 10.8172 11.6849 10.5839L8.32656 9.41719C7.66823 9.18385 7.22656 8.82552 7.22656 7.80885C7.22656 6.87552 7.95156 6.11719 8.84323 6.11719H10.9349C11.9599 6.11719 12.7849 6.98385 12.7849 8.05885"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 5V15"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.5 18.3327H7.5C3.33333 18.3327 1.66666 16.666 1.66666 12.4993V7.49935C1.66666 3.33268 3.33333 1.66602 7.5 1.66602H12.5C16.6667 1.66602 18.3333 3.33268 18.3333 7.49935V12.4993C18.3333 16.666 16.6667 18.3327 12.5 18.3327Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.22656 11.9422C7.22656 13.0172 8.05156 13.8839 9.07656 13.8839H11.1682C12.0599 13.8839 12.7849 13.1255 12.7849 12.1922C12.7849 11.1755 12.3432 10.8172 11.6849 10.5839L8.32656 9.41719C7.66823 9.18385 7.22656 8.82552 7.22656 7.80885C7.22656 6.87552 7.95156 6.11719 8.84323 6.11719H10.9349C11.9599 6.11719 12.7849 6.98385 12.7849 8.05885"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 5V15"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.5 18.3327H7.5C3.33333 18.3327 1.66666 16.666 1.66666 12.4993V7.49935C1.66666 3.33268 3.33333 1.66602 7.5 1.66602H12.5C16.6667 1.66602 18.3333 3.33268 18.3333 7.49935V12.4993C18.3333 16.666 16.6667 18.3327 12.5 18.3327Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		text: "subscription",
		content: [
			{
				title: "Packages",
				to: "/packages",
				text: "packages",
				role: "packages",
			},
			{
				title: "Subscription",
				to: "/subscription",
				text: "subscription",
				role: "subscription",
			},
		],
	},

	// Reports
	{
		title: "Reports",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M17.5 5.83366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167V5.83366C2.5 3.33366 3.75 1.66699 6.66667 1.66699H13.3333C16.25 1.66699 17.5 3.33366 17.5 5.83366Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 3.75V5.41667C12.0833 6.33333 12.8333 7.08333 13.75 7.08333H15.4167"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.66667 10.833H10"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.66667 14.167H13.3333"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M17.5 5.83366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167V5.83366C2.5 3.33366 3.75 1.66699 6.66667 1.66699H13.3333C16.25 1.66699 17.5 3.33366 17.5 5.83366Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 3.75V5.41667C12.0833 6.33333 12.8333 7.08333 13.75 7.08333H15.4167"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.66667 10.833H10"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.66667 14.167H13.3333"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		text: "reports",
		content: [
			{
				title: "Matches",
				to: "/matches-reports",
				text: "matches",
				role: "reports",
			},
			// {
			// 	title: "Tournaments",
			// 	to: "/tournaments",
			// 	text: "tournaments",
			// },
			{
				title: "Booking",
				to: "/booking-reports",
				text: "booking",
				role: "reports",
			},
			{
				title: "Subscriptions",
				to: "/subscription-reports",
				text: "subscriptions",
				role: "reports",
			},
			{
				title: "Users",
				to: "/users-reports",
				text: "users",
				role: "reports",
			},
		],
	},

	// CMS
	{
		title: "CMS",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.5 10.834C6.95 11.109 6.49167 11.5173 6.15 12.0257C5.95833 12.3173 5.95833 12.684 6.15 12.9757C6.49167 13.484 6.95 13.8923 7.5 14.1673"
					stroke="white"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.675 10.834C13.225 11.109 13.6833 11.5173 14.025 12.0257C14.2167 12.3173 14.2167 12.684 14.025 12.9757C13.6833 13.484 13.225 13.8923 12.675 14.1673"
					stroke="white"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7.5 18.3327H12.5C16.6667 18.3327 18.3333 16.666 18.3333 12.4993V7.49935C18.3333 3.33268 16.6667 1.66602 12.5 1.66602H7.5C3.33333 1.66602 1.66667 3.33268 1.66667 7.49935V12.4993C1.66667 16.666 3.33333 18.3327 7.5 18.3327Z"
					stroke="white"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M1.85833 6.67435L17.875 6.66602"
					stroke="white"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.5 10.833C6.95 11.108 6.49167 11.5163 6.15 12.0247C5.95833 12.3163 5.95833 12.683 6.15 12.9747C6.49167 13.483 6.95 13.8913 7.5 14.1663"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.675 10.833C13.225 11.108 13.6833 11.5163 14.025 12.0247C14.2167 12.3163 14.2167 12.683 14.025 12.9747C13.6833 13.483 13.225 13.8913 12.675 14.1663"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7.5 18.3337H12.5C16.6667 18.3337 18.3333 16.667 18.3333 12.5003V7.50033C18.3333 3.33366 16.6667 1.66699 12.5 1.66699H7.5C3.33333 1.66699 1.66667 3.33366 1.66667 7.50033V12.5003C1.66667 16.667 3.33333 18.3337 7.5 18.3337Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M1.85833 6.67533L17.875 6.66699"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "",
		text: "cms",
		content: [
			{
				title: "About Us",
				to: "/about-us",
				text: "about_us",
				role: "cms",
			},
			// Privacy
			{
				title: "Privacy",
				to: "/privacy-policy",
				text: "privacy",
				role: "cms",
			},
			// FAQ
			{
				title: "FAQs",
				to: "/faqs",
				text: "faqs",
				role: "cms",
			},
			// Banner
			{
				title: "Banner",
				to: "/banner",
				text: "banner",
				role: "cms",
			},
			// Advertisement Splash
			{
				title: "Advertisement Splash",
				to: "/advertisement-splash",
				text: "advertisement_splash",
				role: "cms",
			},
			// Onboarding
			{
				title: "Onboarding",
				to: "/onboarding",
				text: "onboarding",
				role: "cms",
			},
		],
	},
];
